import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfHX",
  "use": "BankOfHX-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"BankOfHX\">\r\n<defs>\r\n    <style>\r\n      #BankOfHX .cls-1 {\r\n        fill: #e60012;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfHX_华夏logo\" class=\"cls-1\" d=\"M4284.59,211.2l-2.41-3.11s-9.44,1.555-9.24-3.789c0,0,.67-3.983-6.17-2.429,0,0-1.64-1.553-1.54-2.429,0,0,.48-2.332-6.94-1.069,0,0-10.98,1.361-23.02,15.254,0,0-12.14,10.007-12.14-.292,0,0-6.64,6.8-3.08,12.243,0,0,4.05,5.732,11.75,1.069,0,0-2.4,18.848,9.92,28.661,0,0,12.91,12.048,27.75,7.773,0,0,12.42-2.623,17.14-15.254,0,0-2.21,2.234-3.17,2.041,0,0,3.37-4.081,3.56-5.83,0,0-.1-2.429-2.02,1.36,0,0,.48-2.332-0.87-1.166,0,0-6.55,7.675-9.34,8.063,0,0-20.72,12.34-30.16-12.532,0,0-4.04-11.757,5.49-20.6s18.88-7.966,27.46-1.554c0,0,4.33-4.955,6.16-3.984,0,0,1.64-.971.87-2.429h0Zm0,0-28.71,11.816,21.07-.1v16.167h-21.07V223.016Zm0,0\" transform=\"translate(-4219 -197.016)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfHX.svg
// module id = sSQl
// module chunks = 37